import React from "react";

import { toggleSavePlan, clearAllComparePlans } from "ComparePlans/redux";
import EnrolledPolicyPlansLoader from "QuotePage/Components/EnrolledPolicyPlansLoader";
import { getSavedPlans } from "QuotePage/Selectors";
import { downloadDecisionPacketURL, comparePageURL } from "QuotePage/urls";
import { connect } from "react-redux";
import _ from "underscore";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import SavedPlansTray from "Common/SavedPlansTray";
import { inABTest, showMobileCompare } from "Common/Selectors";

const ANALYTICS_LOCATION = "compare_plans_tray";

const mapStateToProps = (state, ownProps) => {
  // Find the already-loaded plans that are saved
  const loadedPlans = [...getSavedPlans(state), ...(ownProps.enrolledPlans || [])];

  const plans = state.savedPlanIDs.map((planID) => loadedPlans.find((plan) => plan?.id === planID));

  // Any referenced IDs which don't live in the plans list must be still
  // loading.
  const plansLoading = _.range(4).map((index) => state.savedPlanIDs[index] && !plans[index]);

  const planIDs = state.savedPlanIDs;
  return {
    downloadDecisionPacketURL: downloadDecisionPacketURL({
      relative: false,
      searchParams: { plan_ids: planIDs },
    }),

    comparePageURL: comparePageURL(),
    onClickCompareLink: () => {
      // XXX - figure out a more succinct way of doing this.
      AnalyticsTracking.trackEvent("plans_compared", {
        location: ANALYTICS_LOCATION,
        number_of_plans_compared: state.savedPlanIDs.length,
        plan_ids: state.savedPlanIDs,
      });

      AnalyticsTracking.trackEvent("quote_page_click_compare_plans", {
        location: ANALYTICS_LOCATION,
      });
    },
    plans,
    planIDs,
    plansLoading,
    shouldShowSimplePlanName: inABTest(state, "plan_name_simplification"),
    showMobileCompare: showMobileCompare(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onToggleSavePlan: (planID, location) => {
    dispatch(toggleSavePlan(planID, location));
  },
  onClickClearAllLink: () => {
    AnalyticsTracking.trackEvent("clear_all_link_clicked", {
      location: ANALYTICS_LOCATION,
    });

    dispatch(clearAllComparePlans());
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onClickCompareLink: () => {
    stateProps.onClickCompareLink();
  },
});

const ConnectedSavedPlansTray = connect(mapStateToProps, mapDispatchToProps, mergeProps)(SavedPlansTray);

/**
 * This component is only used in the QuotePage App,
 * So loadding the enrolledPlans here to avoid obfuscation in the QuotePage App file.
 */
const HydratedSavedPlansTray = (props) => (
  <EnrolledPolicyPlansLoader>
    {({ medicalPlans: enrolledPlans }) => <ConnectedSavedPlansTray {...props} enrolledPlans={enrolledPlans} />}
  </EnrolledPolicyPlansLoader>
);

export default HydratedSavedPlansTray;
